module.exports = __webpack_public_path__ + "static/media/miss-dior.2bb676c5.png";